<template>
  <div class="success">
    <div class="detailCon" ref="detailCon">
      <img src="../assets/img/bm_icon_5.png" alt="" class="banner">
      <div class="content" v-if="infos.name">
        <img :src="infos.logo+'?'+new Date().getTime()" alt="" class="avatar" crossOrigin="anonymous">
        <div class="form_wrap">
          <div class="wrap_list">
            <div class="list_title">
              <div class="title">
                <span>编</span><span>号</span>
              </div>
            </div>
            <div class="list_right">
              {{ infos.no }}
            </div>
          </div>
          <div class="wrap_list">
            <div class="list_title">
              <div class="title">
                <span>姓</span><span>名</span>
              </div>
            </div>
            <div class="list_right">
              {{ infos.name }}
            </div>
          </div>
          <div class="wrap_list">
            <div class="list_title">
              <div class="title">
                <span>手</span><span>机</span><span>号</span><span>码</span>
              </div>
            </div>
            <div class="list_right">
              {{ infos.mobile }}
            </div>
          </div>
          <div class="wrap_list">
            <div class="list_title">
              <div class="title">
                <span>所</span><span>在</span><span>赛</span><span>区</span>
              </div>
            </div>
            <div class="list_right">
              {{ infos.city }}
            </div>
          </div>
          <div class="wrap_list">
            <div class="list_title">
              <div class="title">
                <span>身</span><span>份</span><span>证</span><span>号</span>
              </div>
            </div>
            <div class="list_right">
              {{ infos.id_card }}
            </div>
          </div>
        </div>
      </div>
      <div class="qrcodes">
        <img src="../assets/img/qrcode.png" alt="" class="qrcode">
        <div class="smart">( <span>扫一扫关注赛事咨询</span> )</div>
      </div>
    </div>
    <img :src="poster" alt="" class="poster">
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import html2canvas from "html2canvas";
export default {
  data () {
    return {
      infos: {
        name: '',
        mobile: '',
        id_card: '',
        no: '',
        city: '',
        logo: ''
      },
      poster: ''
    }
  },
  mounted () {
    this.getInfo();
    this.getShareConfig();
  },
  methods: {
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为优秀的歌手提供卫星电视的播出平台，欢迎您的参与！', // 分享描述
                    link: location.origin + '/#/', // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
    getInfo () {
      this.axios.post('/api/Index/getCertInfo', {
        shareid: localStorage.getItem('shareId')
      })
        .then(({data}) => {
          if (data.code === 1) {
            this.infos = data.data;
            setTimeout(() => {
              this.canvasInit();
            }, 200);
          } else {
            this.Toast(data.msg);
          }
        });
    },
    canvasInit () {
      this.screenshotToBase(this.$refs.detailCon).then(baseUrl => {
        this.poster = baseUrl;
      });
    },
    // 截图工具，返回base64
    screenshotToBase(ele) {
      return new Promise(resolve => {
        html2canvas(ele, {
          scale: 2,
          useCORS: true,
          tainttest:true,
          logging: false
        }).then(canvas => {
          const imgUrl = canvas.toDataURL("image/png");
          resolve(imgUrl);
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .success{
    min-height:100vh;
    background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
    position: relative;
    .detailCon{
      position: relative;
      z-index: -1;
      background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
      padding-bottom:50px;
      min-height:100vh;
    }
    .top_title{
      font-size:42px;
      color:#fff;
      line-height:70px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 10px;
    }
    .content1{
      min-height:500px;
      padding-top:240px;
    }
    .avatar{
      width:180px;
      height:180px;
      object-fit: cover;
      border:3px solid #144ab3;
      border-radius: 20px;
      background:#203a88;
      display:block;
      margin:50px auto 0;
    }
    .form_wrap{
      padding: 30px 60px 50px;
      .wrap_list{
        display:flex;
        align-items: center;
        justify-content: space-between;
        min-height:90px;
        &.nofixed{
          align-items: flex-start;
          margin-top:20px;
        }
        .list_title{
          display:flex;
          align-items: center;
          justify-content: space-between;
          font-weight: bold;
          position:relative;
          padding:0 10px;
          &.after{
            &:before{
              line-height:48px;
              content: '*';
              display:block;
              position:absolute;
              left:-20px;
              top:5px;
              color:#fff;
            }
          }
          &:after{
            line-height:48px;
            content: ':';
            display:block;
            position:absolute;
            right:-15px;
            top:0px;
            color:#fff;
          }
          .title{
            width:140px;
            font-size:28px;
            // text-align: justify;
            // text-align-last: justify;
            display:flex;
            justify-content: space-between;
            line-height:48px;
            color:#fff;
          }
          span{
            color:#fff;
            font-size:30px;
          }
        }
        .list_right{
          width:420px;
          min-height:60px;
          border-radius: 40px;
          font-size:26px;
          background:#fff;
          line-height:60px;
          padding: 0 30px;
          font-family: "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
          color:#888;
        }
      }
    }
    .success_title{
      text-align: center;
      font-size:40px;
      font-weight: 600;
      letter-spacing: 10px;
      color:#fff;
    }
    .qrcodes{
      text-align: center;
      .qrcode{
        width:200px;
        height:200px;
        pointer-events: auto;
      }
      .smart{
        font-size:20px;
        color:#fff;
        margin-top:20px;
        span{
          letter-spacing: 5px;
        }
      }
    }
    .rules{
      padding:40px 50px;
      .rule{
        font-size:24px;
        color:#fff;
        line-height:40px;
        letter-spacing: 5px;
      }
    }
    .poster{
      pointer-events: auto;
      position:absolute;
      top:0;
      left:0;
      // height:100vh;
    }
  }
</style>